import { useState, useEffect } from "react";
import Chart from "chart.js/auto";
import { Pie } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import { TextInput, Slider } from "@mantine/core";
import { useForm } from "@mantine/form";
// import { Tooltip } from "react-tooltip";
Chart.register(CategoryScale);
const Kubera = () => {
        const [value, setValue] = useState("yes");
        // const [val, setVal] = useState(5338);

        // const handleChange = (e :any) => {
        //   const regex = /^[0-9\b]+$/;
        //   if (e.target.value === "" || regex.test(e.target.value)) {
        //     setVal(e.target.value);
        //   }
        // };
       
//         const [users, setUsers] = useState([])

//         const fetchUserData = () => {
//           fetch("http://webapis.bhimagold.com/api_db.js/api/v1//todaysgoldrate")
//             .then(response => {
//               return response.json()
//             })
//             .then(data => {
//               setUsers(data)
              
//             })
//         }

//         const values = Object.values(users);
//       const goldRate = values[1];
// console.log(goldRate);



        const formatter = new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'INR',
                maximumFractionDigits: 2,
          });

 

  
        const form = useForm({
                initialValues: {
                        installmentAmt: 2000,
                        numInstallment: 11,
            makingCharges: 40,
            accumulatedweight: 5,
            goldprice:5000,
            goldweight:3,
                },

                validate: {
                        installmentAmt: (value) => (value <= 2000 ? null : "Amount must be greater than 0"),
                },
        });

        const form1 = useForm({
            initialValues: {
                installmentAmt:2000,
                goldrateMo1:5300, 
                goldrateMo2:5335,
                goldrateMo3:5389,
                goldrateMo4:5400,
                goldrateMo5:5489,
                goldrateMo6:5449,
                goldrateMo7:5649,
                goldrateMo8:5650,
                goldrateMo9:5325,
                goldrateMo10:5360,
                goldrateMo11:5399,

            },
       
           
    });
//     const onKeyPress = (event:any) => {
//         if (!event.key.match(/[0-9]{4}/)) {
//           event.preventDefault();
//         //   alert("it should be 4 digit number")
//         }
//       };

        var result = (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges ) / 100
       // console.log(result);
        const getDiscount = () => {
        
        if (form.values.numInstallment === 11){
            return (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges / 2) / 100;
        }
                if (form.values.numInstallment < 7) {
                        return 0;
                } else 
                if (form.values.numInstallment === 7){
                        return result * 10 / 100;
                }
                else
                if(form.values.numInstallment === 8){
                        return result * 20 / 100;
                }
                else if(form.values.numInstallment === 9){
                        return result * 30 / 100;
                }
                else if(form.values.numInstallment === 10){
                        return result * 40 / 100;
                }
                else
                
                        {
                                return (form.values.installmentAmt * 1);
                        }
                
        };
        const getweightgrid1 =() => (form.values.installmentAmt) / form1.values.goldrateMo1;
        const getweightgrid2 =() => (form.values.installmentAmt) / form1.values.goldrateMo2;
        const getweightgrid3 =() => (form.values.installmentAmt) / form1.values.goldrateMo3;
        const getweightgrid4 =() => (form.values.installmentAmt) / form1.values.goldrateMo4;
        const getweightgrid5 =() => (form.values.installmentAmt) / form1.values.goldrateMo5;
        const getweightgrid6 =() => (form.values.installmentAmt) / form1.values.goldrateMo6;
        const getweightgrid7 =() => (form.values.installmentAmt) / form1.values.goldrateMo7;
        const getweightgrid8 =() => (form.values.installmentAmt) / form1.values.goldrateMo8;
        const getweightgrid9 =() => (form.values.installmentAmt) / form1.values.goldrateMo9;
        const getweightgrid10 =() => (form.values.installmentAmt) / form1.values.goldrateMo10;
        const getweightgrid11 =() => (form.values.installmentAmt) / form1.values.goldrateMo11;
const getTotalWeight =() => getweightgrid1()+getweightgrid2()+getweightgrid3()+getweightgrid4()+getweightgrid5()+getweightgrid6()+getweightgrid7()+getweightgrid8()+getweightgrid9()+getweightgrid10()+getweightgrid11();

        const getTotal =() => form.values.installmentAmt * form.values.numInstallment;
        const getDiscountPerc = () =>  Math.trunc(getDiscount() / getWorth() * 100);
        const getROI = () =>  Math.trunc(getDiscount() / (form.values.installmentAmt * form.values.numInstallment)) * 100;
        const getWorth = () => getDiscount() + form.values.installmentAmt * form.values.numInstallment;
    const getweight =() => (form.values.installmentAmt * form.values.numInstallment) / form.values.goldprice
const minValue = getTotal()/(form.values.goldprice*1.10);
const maxValue = getTotal()/(form.values.goldprice*0.75);
const  worth = () => getTotalWeight() * (form.values.makingCharges/200)
const getjewelworth = () => getTotalWeight()+ worth();
//const roundedNumber1 = Math.round(worth());
var roundedNumber2 : any = worth().toFixed(3);
var roundedNumber3 : any = getTotalWeight().toFixed(3);
console.log(roundedNumber3)

    //const val
    const getChartData = () => {
        const discount = worth();
        const amount = getTotalWeight();
        const Data = [
                {
                        label: `Benefit Offered (${discount.toFixed(3)}g)`,
                        amount: worth(),
          },
                {
                        label: `Total Accumulated Weight (${amount.toFixed(3)}g)`,
                        amount: getTotalWeight(),
          },
          
          
        ];
                
        


        return {
                labels: Data.map((data) => data.label),
                datasets: [
                        {
                                data: Data.map((data) => data.amount),
                                backgroundColor: ["#f3ba2f", "#2a71d0"],
                                borderColor: "#555",
                                borderWidth: 2,
                        },
                ],
        };
};

const [chartData, setChartData] = useState(getChartData());

useEffect(() => {
        setChartData(getChartData());
        //fetchUserData();

}, [form.values.installmentAmt, form.values.makingCharges, form.values.numInstallment, form1.values.goldrateMo1, form1.values.goldrateMo2, form1.values.goldrateMo3, form1.values.goldrateMo4, form1.values.goldrateMo5,form1.values.goldrateMo6,form1.values.goldrateMo7,form1.values.goldrateMo8,form1.values.goldrateMo9,form1.values.goldrateMo10,form1.values.goldrateMo11]);
    return (
   
                <div className="page-content">
                        {/* <h1 style={{ color: "#980717", fontStyle: "italic" }}>Kubera Plan</h1> */}
                        <div style={{ display: "flex", gap: "10px" }}>
      <div className="container-fluid">
                                <div className="row">
                                <div className="col-md-4">
                                       
                                <form onSubmit={form.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
                                        
                                <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <label>Installment Amount</label>
                                                        <div>{formatter.format(form.values.installmentAmt)
                                                        }</div>
                                                </div>
                                                <Slider {...form.getInputProps("installmentAmt")} min={2000} max={100000} step={1000}/>
                                        </div>
                               
    {/* <div>
 Today's Gold Rate:   {goldRate}
        </div> */}

                    {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <label>Gold Rate:</label>
                                                        <div>{formatter.format(form.values.goldprice)}</div>
                                                </div>
                                                <Slider {...form.getInputProps("goldprice")} min={5000} max={7500} />
                                        </div> */}

                                                                       
                    {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <label>No. of Installments:</label>
                                                        <div>{form.values.numInstallment}</div>
                                                </div>
                                                <Slider {...form.getInputProps("numInstallment")} min={1} max={11} />
                                        </div> */}
                                                                                <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <label>No. of Installments :</label>
    <div>{form.values.numInstallment}</div>
  </div>
  <div style={{ position: "relative", width: "100%" }}>
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "8px",
        background: "#228be6",
        borderRadius: "5px",
        zIndex: 0,
      }}
    />
    <div
      style={{
        position: "absolute",
        width: "calc(100% * 11 / 11)", // This sets the width to 100% when the value is 11
        height: "8px",
        background: "#228be6",
        borderRadius: "5px",
        zIndex: 1,
      }}
    />
    <input
      type="range"
      min={1}
      max={11}
      step={1}
      value={form.values.numInstallment}
      disabled // Disable the slider interaction
      style={{
        width: "100%",
        height: "8px",
        cursor: "default",
        opacity: 0,
        zIndex: 2,
      }}
    />
  </div>
  {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <label>Gold Weight in </label>
                                                        <div>{form.values.goldweight}gm</div>
                                                </div>
                                                <Slider {...form.getInputProps("goldweight")} min={minValue} max={maxValue} step={0.001} defaultValue={minValue}/>
                                        </div>   */}
</div>
<div></div>

{/* return (
    <div>
     
        <ul>
          {users.gold22k}
        </ul>
      
    </div>
  ); */}

                    
                                        <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <label>Net Making Charges:</label>
                                                        <div>{form.values.makingCharges}%</div>
                                                </div>
                                                <Slider {...form.getInputProps("makingCharges")} min={2} max={40} />
                                        </div>
                                        
                                </form> 
                                                
                                 <br></br>
                                </div>
                                <br></br>
                                <div className="col-md-5">

<table className="table table-striped ">
<thead>
{/* <tr>
<td>Total Amount Paid:</td>
<td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div></td>

</tr> */}
</thead>
<tbody>
<tr>
<td>Total Accumulated Weight:</td>
<td> <div className="bold" style={{ textAlign: "right" }}>{getTotalWeight().toFixed(3)}g</div></td>

</tr>
<tr>
<td>Total Benefit Offered:</td>
<td> <div className="bold" style={{ textAlign: "right" }}>{worth().toFixed(3)}g</div></td>
</tr>

<tr>
<td>Get Jewellery Worth:</td>
<td><div className="bold" style={{ textAlign: "right" }}>{getjewelworth().toFixed(3)}g</div></td>
</tr>

</tbody>
</table>



        
        <div className="card">
<div className="card-body">
<b>Benefit:</b> <br></br>
{/* No need to pay Making charges<b>{formatter.format(getDiscount())}</b>  on product worth <b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</b>
{' '} (Effectively you got benefit worth <b>{formatter.format(getDiscount())}</b> in this case) */}
You need to pay only 50% of Making charges on Product(s) weighing <b>{getTotalWeight().toFixed(3)}g</b> (Effectively you get benefit worth <b>{worth().toFixed(3)}g of 22Kt Gold</b> in this case)


</div>

</div>




        {/* <div>
                <label>You would effectively pay</label>
                <div className="bold">{form.values.installmentAmt * form.values.numInstallment}</div>
        </div> */}

<br></br>     
      
</div>
                                <div className="col-md-3">
                                        <Pie data={chartData} />
                                
                                </div>
                        </div>
<br></br>
                        <div className="row">

                        <form onSubmit={form1.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
<table className="table-responsive-sm table-bordered table table-striped">
<thead className="thead-dark">
<tr>
<td><b>No. of Inst.</b></td>
<td><b>Inst.Amount in Rs</b></td>
<td><b>Gold Rate on the day of payment</b></td>
<td style={{textAlign :'center'}}><b>Accumulated Wt. in grams</b></td>
</tr>
</thead>
<tbody>
<tr><td>1 </td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo1")} /></td>
<td className="grid">{getweightgrid1().toFixed(3)}</td></tr>
<tr><td>2 </td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo2")}/></td>
<td className="grid">{getweightgrid2().toFixed(3)}</td></tr>
<tr><td>3 </td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo3")}  /></td>
<td className="grid">{getweightgrid3().toFixed(3)}</td></tr>
<tr><td>4 </td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo4")}  /></td>
<td className="grid">{getweightgrid4().toFixed(3)}</td></tr>
<tr><td>5 </td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo5")}  /></td>
<td className="grid">{getweightgrid5().toFixed(3)}</td></tr>
<tr><td>6 </td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo6")}  /></td>
<td className="grid">{getweightgrid6().toFixed(3)}</td></tr>
<tr><td>7</td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo7")}  /></td>
<td className="grid">{getweightgrid7().toFixed(3)}</td></tr>
<tr><td>8 </td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo8")}  /></td>
<td className="grid">{getweightgrid8().toFixed(3)}</td></tr>
<tr><td>9</td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo9")}  /></td>
<td className="grid">{getweightgrid9().toFixed(3)}</td></tr>
<tr><td>10 </td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo10")}  /></td>
<td className="grid">{getweightgrid10().toFixed(3)}</td></tr>
<tr><td>11</td>
<td><div>{formatter.format(form.values.installmentAmt)}</div></td>
<td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo11")}  /></td>
<td className="grid">{getweightgrid11().toFixed(3)}</td></tr>
<tr>
<td style={{ fontSize : '20px'}}><b>Total</b></td>
<td style={{ fontSize : '20px'}}><b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</b></td>
<td className="grid" style={{ textAlign :'right'}}>
        {/* Total Accumulated Wt. in grams */}
        </td>
<td className="grid" style={{ fontSize : '20px'}}>{getTotalWeight().toFixed(3)}g</td>
</tr>
</tbody>

</table>
</form>
</div>
                </div>
                </div>
                </div>
        );
};

export default Kubera;


// import { useState, useEffect } from "react";
// import Chart from "chart.js/auto";
// import { Pie } from "react-chartjs-2";
// import { CategoryScale } from "chart.js";
// import { TextInput, Slider } from "@mantine/core";
// import { useForm } from "@mantine/form";

// Chart.register(CategoryScale);
// const Kuberaold = () => {
//         const [value, setValue] = useState("yes");
//         const [users, setUsers] = useState([])

//         const fetchUserData = () => {
//           fetch("http://webapis.bhimagold.com/api_db.js/api/v1//todaysgoldrate")
//             .then(response => {
//               return response.json()
//             })
//             .then(data => {
//               setUsers(data)
              
//             })
//         }

//         var values = JSON.stringify(Object.values(users));
        
// let goldRate = 0;
// if( values.length > 2 ) {
//     var temp = values.split('\",')[1];
//     temp = temp.replace( ",", "" );
//     temp = temp.replace( "\"", "" )
//     goldRate = Number(temp);
//     console.log(goldRate*10)
// }
// //console.log(Object.values(users));
//         const formatter = new Intl.NumberFormat('en-IN', {
// 		style: 'currency',
// 		currency: 'INR',
// 		maximumFractionDigits: 2,
// 	  });

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setValue(e.target.value);
//   };

  
//         const form = useForm({
//                 initialValues: {
//                         installmentAmt: 5000,
//                         numInstallment: 11,
//             makingCharges: 40,
//             accumulatedweight: 5,
//             goldprice:5000,
//             goldweight:9.5,
//                 },

//                 validate: {
//                         installmentAmt: (value) => (value <= 2000 ? null : "Amount must be greater than 0"),
//                 },
//         });

//         var result = (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges ) / 100
//        // console.log(result);
//         const getDiscount = () => {
        
//         if (form.values.numInstallment === 11){
//             return (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges / 2) / 100;
//         }
//                 if (form.values.numInstallment < 7) {
//                         return 0;
//                 } else 
//                 if (form.values.numInstallment === 7){
//                         return result * 10 / 100;
//                 }
//                 else
//                 if(form.values.numInstallment === 8){
//                         return result * 20 / 100;
//                 }
//                 else if(form.values.numInstallment === 9){
//                         return result * 30 / 100;
//                 }
//                 else if(form.values.numInstallment === 10){
//                         return result * 40 / 100;
//                 }
//                 else
                
//                         {
//                                 return (form.values.installmentAmt * 1);
//                         }
                
//         };
//         const getTotal =() => form.values.installmentAmt * form.values.numInstallment;
//         const getDiscountPerc = () =>  Math.trunc(getDiscount() / getWorth() * 100);
//         const getROI = () =>  Math.trunc(getDiscount() / (form.values.installmentAmt * form.values.numInstallment)) * 100;
//         const getWorth = () => getDiscount() + form.values.installmentAmt * form.values.numInstallment;
//     const getweight =() => (form.values.installmentAmt * form.values.numInstallment) / goldRate
// const minValue = getTotal()/(goldRate*1.10);
// const maxValue = getTotal()/(goldRate*0.75);

//     //const val
//     const getChartData = () => {
//         const discount = getDiscount();
//         const amount = getTotal();
//         const Data = [
//                 {
//                         label: `Benefit Offered (${formatter.format(discount)})`,
//                         amount: getDiscount(),
//           },
//                 {
//                         label: `Amount Paid (${formatter.format(amount)})`,
//                         amount: getTotal(),
//           },
          
          
//         ];
                
        


//         return {
//                 labels: Data.map((data) => data.label),
//                 datasets: [
//                         {
//                                 data: Data.map((data) => data.amount),
//                                 backgroundColor: ["#f3ba2f", "#2a71d0"],
//                                 borderColor: "#555",
//                                 borderWidth: 2,
//                         },
//                 ],
//         };
// };

// const [chartData, setChartData] = useState(getChartData());

// useEffect(() => {
//         setChartData(getChartData());
//         fetchUserData();

// }, [form.values.installmentAmt, form.values.makingCharges, form.values.numInstallment]);
//     return (
   
//                 <div className="page-content">
//                         {/* <h1 style={{ color: "#980717", fontStyle: "italic" }}>Kubera Plan</h1> */}
//                         <div style={{ display: "flex", gap: "10px" }}>
//       <div className="container-fluid">
//                                 <div className="row">
//                                 <div className="col-md-4">
                                       
//                                 <form onSubmit={form.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
                                        
//                                 <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Installment Amount</label>
//                                                         <div>{formatter.format(form.values.installmentAmt)}</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("installmentAmt")} min={5000} max={1000000} step={1000}/>
//                                         </div>
                               
//     <div>
//  Today's Gold Rate:   {goldRate}
// 	</div>

//                     {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Gold Rate:</label>
//                                                         <div>{formatter.format(form.values.goldprice)}</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("goldprice")} min={5000} max={7500} />
//                                         </div> */}

                                                                       
//                     {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>No. of Installments:</label>
//                                                         <div>{form.values.numInstallment}</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("numInstallment")} min={1} max={11} />
//                                         </div> */}
// 										<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//   <div style={{ display: "flex", justifyContent: "space-between" }}>
//     <label>No. of Installments :</label>
//     <div>{form.values.numInstallment}</div>
//   </div>
//   <div style={{ position: "relative", width: "100%" }}>
//     <div
//       style={{
//         position: "absolute",
//         width: "100%",
//         height: "8px",
//         background: "#ccc",
//         borderRadius: "5px",
//         zIndex: 0,
//       }}
//     />
//     <div
//       style={{
//         position: "absolute",
//         width: "calc(100% * 11 / 11)", // This sets the width to 100% when the value is 11
//         height: "8px",
//         background: "#2a71d0",
//         borderRadius: "5px",
//         zIndex: 1,
//       }}
//     />
//     <input
//       type="range"
//       min={1}
//       max={11}
//       step={1}
//       value={form.values.numInstallment}
//       disabled // Disable the slider interaction
//       style={{
//         width: "100%",
//         height: "8px",
//         cursor: "default",
//         opacity: 0,
//         zIndex: 2,
//       }}
//     />
//   </div>
//   <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Gold Weight in gms</label>
//                                                         <div>{form.values.goldweight}gm</div>
//                                                 </div>


                                                
//                                                 <Slider {...form.getInputProps("goldweight")} min={minValue} max={maxValue} step={0.001} defaultValue={minValue}/>
//                                         </div>  
// </div>
// <div></div>

// {/* return (
//     <div>
     
//         <ul>
//           {users.gold22k}
//         </ul>
      
//     </div>
//   ); */}

                    
//                                         <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Making Charges:</label>
//                                                         <div>{form.values.makingCharges}%</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("makingCharges")} min={2} max={40} />
//                                         </div>
                                        
//                                 </form>  <br></br>
//                                 </div>
//                                 <br></br>
//                                 <div className="col-md-5">

// <table className="table table-striped">
// <thead>
// <tr>
// <td>Total Amount Paid:</td>
// <td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div></td>

// </tr>
// </thead>
// <tbody>
// <tr>
// <td>Total Accumulated Weight:</td>
// <td> <div className="bold" style={{ textAlign: "right" }}>{getweight().toFixed(3) }gms</div></td>

// </tr>
// <tr>
// <td>Total Benefit Offered:</td>
// <td> <div className="bold" style={{ textAlign: "right" }}>{formatter.format(getDiscount())}</div></td>
// </tr>

// <tr>
// <td>Get Jewellery Worth:</td>
// <td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(getWorth())}</div></td>
// </tr>

// </tbody>
// </table>



        
//         <div className="card">
// <div className="card-body">
// <b>Benefit:</b> <br></br>
// No need to pay Making charges<b>{formatter.format(getDiscount())}</b>  on product worth <b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</b>
// {' '} (Effectively you got benefit worth <b>{formatter.format(getDiscount())}</b> in this case)


// </div>

// </div>

//         {/* <div>
//                 <label>You would effectively pay</label>
//                 <div className="bold">{form.values.installmentAmt * form.values.numInstallment}</div>
//         </div> */}

// <br></br>     
      
// </div>
//                                 <div className="col-md-3">
//                                         <Pie data={chartData} />
                                
//                                 </div>
//                         </div>
//                 </div>
//                 </div>
//                 </div>
//         );
// };

// export default Kuberaold;